// Set up input variables
const giftRewards = document.querySelector('.gift-rewards');
if (giftRewards){
	const donationAmounts = document.querySelectorAll('.charity-amount input[type=number]');
	const intervalUp = document.querySelectorAll('.step-up');
	const intervalDown = document.querySelectorAll('.step-down');
	const donationTotal = document.querySelector('.gifted-total');
	const designText = document.querySelectorAll('.dollar-amount');
	function charityAmount() {
		// Set up the variables
		const intervalButtons = document.querySelectorAll('.step-up, .step-down');
		const totalDonation = document.querySelector('.total-donation');
		const donationMax = document.querySelector('.account-container').getAttribute('data-available');
		if (donationMax == 0) {
			intervalButtons.setAttribute('disabled', 'disabled');
		}
		// Functions when user clicks on interval button
		intervalDown.forEach(btn => {
			btn.addEventListener('click', e => {
				e.target.parentNode.querySelector('input[type=number]').stepDown();
			});	
		});

		intervalUp.forEach(btn => {
			btn.addEventListener('click', e => {
				e.target.parentNode.querySelector('input[type=number]').stepUp();
			});	
		});

		intervalButtons.forEach(btn => {

			btn.addEventListener('click', function(e) {
				// Look for all the charitable amounts and add them up
				let inputValues = [];
				for (let i = 0; i < donationAmounts.length; i++) {
					inputValues.push(parseInt(donationAmounts[i].value));
				}
				let sum = inputValues.reduce(function(a, b){
					return a + b;
				});
				
				// Add up numbers and add them to the hidden field
				totalDonation.value = sum;
				// Use that same number and apply it within the design
				donationTotal.innerHTML = sum;		
				/* 	
				If user clicks the up button, check the amount being donated and the amount the user has in the account 
				and prevent the user from adding more, if user clicks down, re-enable the up button
				*/
				intervalUp.forEach(upBtn => {
					if (sum == donationMax) {
						upBtn.setAttribute('disabled', 'disabled');
					} else {
						upBtn.removeAttribute('disabled', 'disabled');
					}
				});
				
				// Switched to jquery because it just makes more sense
				$('.charity-amount input').each(function() {
					var individualValue = $(this).val();
					$(this).siblings('.tally').children('.dollar-amount').text(individualValue);
				});
			});
		});
		
	};
	charityAmount();
	
	function clearAmounts() {
		const clearButton = document.querySelector('.btn.clear');
		clearButton.addEventListener('click', function(e) {
			donationAmounts.forEach(zeroTotal => {
				zeroTotal.value = 0;
				donationTotal.innerHTML = 0;
			});
			intervalUp.forEach(upBtn => {
				upBtn.removeAttribute('disabled', 'disabled');
			});
			designText.forEach(zeroCharities => {
				zeroCharities.innerHTML = 0;
			});
		});
	};
	clearAmounts();
}


